module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.d902c39b.png";